import React from 'react'
import { Card, Heading } from '@scentregroup/ui'
import PageLanding from '@scentregroup/shared/components/page-landing-v2'
import TableOfContents from '@scentregroup/shared/components/table-of-contents'
import Markdown from '@scentregroup/shared/components/markdown'
import {
  TermsModule,
  Promotion,
  ComparisonModule,
  PromotionFeature,
  isTermsModule,
} from '../../../../../../src/types/content-page'
import style from './index.module.scss'

interface ContentPageProps {
  modules: (Promotion | PromotionFeature | ComparisonModule | TermsModule)[]
  title: string
}

/**
 * used by the terms-and-conditions and privacy-policy pages
 */
const ContentPage: React.FunctionComponent<ContentPageProps> = ({
  title,
  modules,
}) => {
  const termsModules = modules.filter(isTermsModule)

  return (
    <PageLanding heading={title} dataTestId="page-title" logo={undefined}>
      <Card cardPadding={false} className={style.card}>
        <TableOfContents sections={termsModules} />
        {termsModules.map(module => (
          <section key={module.slug} className={style.section}>
            <Heading type="medium" id={module.slug} className={style.heading}>
              {module.title}
            </Heading>
            <Markdown content={module.bodyCopy} key={module.slug} />
          </section>
        ))}
      </Card>
    </PageLanding>
  )
}

export default ContentPage
